<template>
  <div class="golf-outer loaded">
    <div class="home-page login-page">
      <div class="row">
        <div class="col-md-12" v-loading="showLoader">
          <login-board @showLoader="$emit('showLoader')"></login-board>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/shared/api'
export default {
  name: 'LoginPage',
  data () {
    return {
      showLoader: false
    }
  },
  created() {
    if (this.$data.globalData.user) {
      if (this.$data.globalData.user.completed_quiz) {
        this.$router.replace({ path: '/spurningar/' });
      } else {
        if (this.$route.query) {
          if (this.$route.query.next_url && this.$route.query.next_url.indexOf('frjals-spilun') > -1) {
            this.$router.replace({ path: '/frjals-spilun/?showclub=true' });
            return;
          }
        }
        this.$router.replace({ path: '/spurningar/?showclub=true' });
      }
    }
  },
}
</script>
